import { blobticService } from '../../Commun/services/blobticService';

export interface LookupItem {
    id: number;
    uid?: string;
    code: string;
    lib: string;
    lastUpdate?: Date;
}

const mapDto = (dto: any, idKey: string, codeKey: string, libKey: string): LookupItem => ({
    id: dto[idKey],
    uid: dto[idKey.replace('IDF', 'UIDF')],
    code: dto[codeKey],
    lib: dto[libKey],
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined
});

const makeCrud = (objectName: string, prefix: string) => {
    const idKey = `${prefix}_IDF`;
    const codeKey = `${prefix}_CODE`;
    const libKey = `${prefix}_LIB`;

    return {
        getAll: async () => {
            const response = await blobticService.executeZoomRequest({
                ZoomKey: 'Blobtic_Parc',
                Action: { OKey: `Blobtic_Parc,${objectName},Select` }
            });
            if (response.success && Array.isArray(response.data)) {
                return { data: response.data.map((item: any) => mapDto(item, idKey, codeKey, libKey)), success: true };
            }
            return { data: [], success: false, message: response.message };
        },
        create: async (data: { code: string; lib: string }) => {
            const payload: any = {
                OKey: `Blobtic_Parc,${objectName},Insert`,
                [codeKey]: data.code,
                [libKey]: data.lib
            };
            return await blobticService.executeZoomRequest({
                ZoomKey: 'Blobtic_Parc',
                Action: payload
            });
        },
        update: async (id: number, data: { code: string; lib: string }) => {
            const payload: any = {
                OKey: `Blobtic_Parc,${objectName},Update`,
                [idKey]: id,
                [codeKey]: data.code,
                [libKey]: data.lib
            };
            return await blobticService.executeZoomRequest({
                ZoomKey: 'Blobtic_Parc',
                Action: payload
            });
        },
        delete: async (id: number) => {
            const payload: any = {
                OKey: `Blobtic_Parc,${objectName},Delete`,
                [idKey]: id
            };
            return await blobticService.executeZoomRequest({
                ZoomKey: 'Blobtic_Parc',
                Action: payload
            });
        }
    };
};

export const lookupApi = {
    proprietaires: makeCrud('parc_proprietaire', 'PRP'),
    fuelTypes: makeCrud('parc_fuel_type', 'FTP'),
    affectations: makeCrud('parc_affectation', 'AFF'),
    docTypes: makeCrud('parc_doc_type', 'DCT'),
    mntTypes: makeCrud('parc_mnt_type', 'MTP')
};
